import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Box, Typography, makeStyles } from '@material-ui/core';
import moment from 'logic/moment';
import { ACTION_COLORS } from '../constants';

const actionLabels = {
  accept: { id: 'complaints.action.accept', defaultMessage: 'Accepted' },
  reject: { id: 'complaints.action.reject', defaultMessage: 'Rejected' },
  counter_offer: { id: 'complaints.action.counterOffer', defaultMessage: 'Counter-offer' },
  resolve: { id: 'complaints.action.resolve', defaultMessage: 'Resolved' },
};

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(3),
    borderLeft: (props) => `3px solid ${ACTION_COLORS[props.action] || theme.palette.divider}`,
  },
}));

const TimelineEntry = ({ response }) => {
  const classes = useStyles({ action: response.action });
  const actionLabel = actionLabels[response.action];
  const responderLabel = response.responder?.first_name || response.responder_type;
  return (
    <div className={classes.root}>
      <Typography variant="subtitle2">
        {responderLabel}
        {actionLabel && (
          <>
            {responderLabel && ' - '}
            <FormattedMessage {...actionLabel} />
          </>
        )}
      </Typography>
      {response.comment && (
        <Box mt={1} mb={1}>
          <Typography variant="body1" style={{ whiteSpace: 'pre-wrap' }}>
            {response.comment}
          </Typography>
        </Box>
      )}
      {response.offered_compensation != null && (
        <Box mt={1} mb={1}>
          <Typography variant="body2" color="textSecondary">
            <FormattedMessage
              id="complaints.offeredCompensation.label"
              defaultMessage="Offered compensation"
            />
          </Typography>
          <Typography variant="body1">{response.offered_compensation} SEK</Typography>
        </Box>
      )}
      <Box mt={1}>
        <Typography variant="caption" color="textSecondary">
          {moment(response.created_at).format('LLL')}
        </Typography>
      </Box>
    </div>
  );
};

TimelineEntry.propTypes = {
  response: PropTypes.shape({
    id: PropTypes.number,
    action: PropTypes.string,
    comment: PropTypes.string,
    offered_compensation: PropTypes.number,
    responder_type: PropTypes.string,
    responder: PropTypes.shape({
      first_name: PropTypes.string,
    }),
    created_at: PropTypes.string.isRequired,
  }).isRequired,
};

export default TimelineEntry;
